import styled from 'styled-components/macro';

const HighlightsWrapper = styled.div`
  overflow: visible;

  .os-divider {
    width: 0.8rem;
  }
`;

export default HighlightsWrapper;
